module.exports = __webpack_public_path__ + "static/img/ID@3x.760a0c3b.jpg";